export default __webpack_public_path__ + "static/media/Megaphone.5e742995.svg";